<template>
    <div class="button-cover">
          <button class="px-8 py-2" @click="back" >Cancel</button>
          <button class="px-10 py-2" type="submit">Save</button>
    </div>
  </template>
  
  <script>
  export default {
      methods: {
      submitForm() {
        // Handle form submission, e.g., send data to an API or update the state
        console.log('Selected shipping options:', this.selectedShippingOptions);
        // Perform further actions as needed
      },
       back() {
        this.$router.go(-1)
      }
    }
  
  }
  </script>
  
  <style>
  .button-cover{
    width: 90%;
    margin: 10% auto 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .button-cover :nth-child(1){
    border: 1px solid rgba(69, 90, 100, 0.03);
    background: #FFFFFF;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    color: #383F51;
  }
  .button-cover :nth-child(2){
    background: #FCC210;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    color: #383F51;
  }
  </style>